import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appRestrictRightClickandShortcut]'
})
export class RestrictRightClickandShortcutDirective {

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      // event.preventDefault();
    }
  }

  constructor() { }

}
